import "react-app-polyfill/ie11"; // For IE 11 support
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import configureStore from "./store/index";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "bootstrap/dist/css/bootstrap.min.css";
import { SnackbarProvider } from "notistack";
import { PersistGate } from "redux-persist/integration/react";
import ErrorBoundary from "./ErrorBoundary";
import { config } from "@fortawesome/fontawesome-svg-core";
import "@fortawesome/fontawesome-svg-core/styles.css"; // Manual CSS import
import { bindVersionCheckEvents } from "./utils/versionCheck";
const { store, persistor } = configureStore();
config.autoAddCss = false; // Disable automatic inline styles

ReactDOM.render(
  <React.StrictMode>
    <SnackbarProvider
      maxSnack={1}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </PersistGate>
      </Provider>
    </SnackbarProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// Event-driven version check (boot + tab focus). No polling.
bindVersionCheckEvents();

// Keep service worker unregistered so it cannot cache old shells.
serviceWorker.unregister();
